import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Landing.css'

import SpotifyIcon from './spotify.svg';
import AppleIcon from './apple.svg';
import { Clock } from 'lucide-react';

const NavBar = ({ scrollToEmail }) => {
  return (
    <nav className="cosmic-navbar">
      <Link to="/" className="cosmic-logo">orb</Link>
      <div className="cosmic-nav-links">
        <div className="podcast-links">
          <a 
            href="https://open.spotify.com/show/5XUHeIgS6YpEFMpGeH1Suq" 
            target="_blank" 
            rel="noopener noreferrer"
            className="podcast-link"
          >
            <img src={SpotifyIcon} alt="Spotify" className="podcast-icon" />
            <span>Spotify</span>
          </a>
          <a 
            href="https://podcasts.apple.com/us/podcast/orb-find-your-orbit/id1805612469" 
            target="_blank" 
            rel="noopener noreferrer"
            className="podcast-link"
          >
            <img src={AppleIcon} alt="Apple Podcasts" className="podcast-icon" />
            <span>Apple Podcasts</span>
          </a>
        </div>
        <button onClick={scrollToEmail} className="coming-soon-button">
          <Clock size={16} />
          <span>Coming Soon</span>
        </button>
      </div>
    </nav>
  );
};

const StarryBackground = () => {
  const [stars, setStars] = useState([...Array(100)].map((_, i) => ({
    id: i,
    top: `${Math.random() * 100}%`,
    left: `${Math.random() * 100}%`,
    delay: `${Math.random() * 3}s`
  })));

  return (
    <div className="starry-background">
      {stars.map(star => (
        <div
          key={star.id}
          className="star"
          style={{
            top: star.top,
            left: star.left,
            animationDelay: star.delay
          }}
        />
      ))}
    </div>
  );
};

const ShootingStar = () => {
  const [shot, setShot] = useState(false);
    useEffect(() => {
      const timer = setTimeout(() => {
        setShot(true);
      }, 500);
      return () => clearTimeout(timer);
    }, []);

    return shot ? (
      <div className="shooting-star">
        <div className="star-trail" />
      </div>
    ) : null;
};

const OrbitingSystem = () => {
  const [phase, setPhase] = useState(0);
  const phases = ['🌑', '🌒', '🌓', '🌔', '🌕', '🌖', '🌗', '🌘'];

  useEffect(() => {
    const timer = setInterval(() => {
      setPhase(p => (p + 1) % phases.length);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  return (
    <div className="orbit">
      <div className="orbit-ring" />
      <div className="earth">🌎</div>
      <div className="moon-container">
        <div className="moon">{phases[phase]}</div>
      </div>
    </div>
  );
};

const Landing = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [isInputHighlighted, setIsInputHighlighted] = useState(false);
  const emailInputRef = useRef(null);

  const postEmail = async (e) => {
    setSubmitted(true)
    try {
        const response = await fetch('https://us-central1-orb-ai-project.cloudfunctions.net/api/beta', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              email
            })
        });
        console.log(response)
    } catch (error) {
        console.error('There was an error:', error);
    }
  }
  
  const scrollToEmail = () => {
    if (emailInputRef.current) {
      emailInputRef.current.scrollIntoView({ behavior: 'smooth' });
      setIsInputHighlighted(true);
      setTimeout(() => setIsInputHighlighted(false), 2000);
    }
  }

  return (
    <div className="cosmos">
      <NavBar scrollToEmail={scrollToEmail} />
      <div className='cosmic-header'/>
      <StarryBackground />
      {[...Array(3)].map((_, i) => (
        <ShootingStar key={i} />
      ))}
      
      <main className="content">
        <header className="hero">
          <h1>Orb</h1>
          <i className="tagline">Find your orbit</i>
        </header>

        <OrbitingSystem />

        <div className="divider-landing">
          <div className="divider-line-landing"></div>
        </div>

        <p className='subtitle-orb'>Where ancient wisdom meets modern science.</p>
        
        <div className="divider-landing">
          <div className="divider-line-landing"></div>
        </div>

        <div className="cta">
          {!submitted ? (
            <form onSubmit={(e) => {
              e.preventDefault();
              postEmail();
            }}>
              <div className="input-wrapper" ref={emailInputRef}>
                <label className="cosmic-label">Stay tuned...</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your email"
                  className={`cosmic-input ${isInputHighlighted ? 'highlight-input' : ''}`}
                  required
                />
              </div>
              <button type="submit" className="cosmic-button">
                Begin the journey
              </button>
            </form>
          ) : (
            <div className="success">
              <h3>Thank you!</h3>
              <p>Your cosmic journey begins ✨</p>
            </div>
          )}
        </div>

      </main>
      <div className="cosmic-footer"/>
      <p className='cosmic-footer-text'><i>Find your orbit.</i><br></br><br></br>©2025 0rb.ai<br></br>All Rights Reserved.</p>
    </div>
  );
};

export default Landing;